<ng-container
  *rptHandleErrors
  provideElements
  [documentId]="CUID.treemap"
  [reportIndex]="0">

  @if (displayUserHasNoFundsMessage()) {
    <div class="message">
      <wct-no-search-results
        [icon]="'system/info-circle'"
        [headline]="'fondsOverview.noFunds.header' | transloco"
        [message]="'fondsOverview.noFunds.message' | transloco"
        [displayResetButton]="false" />
    </div>
  } @else if (chartElement | element | async) {
    <div
      class="treemap"
      [hidden]="displayingDetails()">
      <wct-doughnut-chart
        [data]="(chartElement | element | async)?.renderable"
        [names]="('Tabelle' | element | async)?.renderable"
        [sum]="'Gesamtbestand' | element | async | elementContentString" />
    </div>
  } @else {
    <div class="wct-relative">
      <sd-4-5-1-spinner class="wct-absolute-center"></sd-4-5-1-spinner>
    </div>
  }
</ng-container>

<ng-container #details></ng-container>

<ng-template #detailsTemplate>
  <wct-fond-details
    [hideBackButton]="displayDetailsHideBackButton"
    [hidden]="!displayingDetails()"
    [selectedFund]="selectedFund()"
    [redirectUrl]="redirectUrl()"
    [name]="selectedFund" />
</ng-template>
